import { createSelector } from 'reselect';

const selectTaxLedgers = (state: any) => state.taxLedgers;


export const selectCurrentItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.current);

export const selectListItems = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.create);

export const selectUpdatedItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.update);

export const selectReadItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.read);

export const selectDeletedItem = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.delete);

export const selectSearchedItems = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.search);

export const selectItemsCount = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.count);

export const selectItemsFilter = createSelector([selectTaxLedgers], (taxLedgers) => taxLedgers.filter);